import lang from 'element-ui/lib/locale/lang/en' // 引入element语言包
const messages = {
  message: {
    'text': 'Good good study, Day day up',
  },
  ...lang,
}

export default messages
